import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./MainLandingPage.css";
import "./login.css";
import mapImg from "../assets/live.jpeg";
import logo from "../assets/d37h13dk.png";
import FadeInSection from "../FadeInSection/FadeInSection";


import whatsappIcon from "../User/pages/10464236.png";
import emailIcon from "../User/pages/Screenshot_7-1-2026_171251_www.freepik.com.jpeg";


import emailActiveIcon from "../User/pages/Screenshot_7-1-2026_171251_www.freepik.com.jpeg";
import axios from "axios";


const Login = () => {
    const navigate = useNavigate();
    const [emailOrMobile, setEmailOrMobile] = useState("");
    const [selectedRole, setSelectedRole] = useState("");
    const [otp, setOtp] = useState("");
    const [otpSent, setOtpSent] = useState(false);
    const [loading, setLoading] = useState(false);


    const isEmail = emailOrMobile.includes("@");

    // ================= SEND OTP =================
    const handleSendOtp = async () => {
        // if (!emailOrMobile) {
        if (!emailOrMobile || !selectedRole) {
            // alert("Please enter email or mobile");
            alert("Please select role and enter email/mobile");
            return;
        }

        setLoading(true);

        try {
             await axios.post("https://api.propertygalleria.in/master/api/api/users/send-otp", {
         //  await axios.post("http://localhost:4001/api/users/send-otp_test", {
                email: isEmail ? emailOrMobile : null,
                mobile: !isEmail ? emailOrMobile : null,
                role: selectedRole,
            });

            setOtpSent(true);
            alert("OTP sent successfully");
        } catch (err) {
            alert(err.response?.data?.message || "Failed to send OTP");
        } finally {
            setLoading(false);
        }
    };

    // ================= VERIFY OTP =================
    const handleVerifyOtp1 = async () => {
        if (!otp) {
            alert("Please enter OTP");
            return;
        }

        setLoading(true);

        try {
            const res = await axios.post(
                "https://api.propertygalleria.in/master/api/api/users/verify-otp_test",
                {
                    email: isEmail ? emailOrMobile : null,
                    mobile: !isEmail ? emailOrMobile : null,
                     role: selectedRole,
                    otp,
                }
            );

            alert("OTP verified successfully");

            localStorage.setItem("user", JSON.stringify(res.data.user));

            navigate("/homee"); // change if needed
        } catch (err) {
            alert(err.response?.data?.message || "Invalid OTP");
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyOtp = async () => {
        if (!otp) {
            alert("Please enter OTP");
            return;
        }

        setLoading(true);

        try {
            // const res = await axios.post(
            //     "https://api.propertygalleria.in/master/api/api/users/verify-otp",
            //     {
            //         email: isEmail ? emailOrMobile : null,
            //         mobile: !isEmail ? emailOrMobile : null,
            //         otp,
            //     }
            // );
              const res = await axios.post(
                "https://api.propertygalleria.in/master/api/api/users/verify-otp",
                {
                    email: isEmail ? emailOrMobile : null,
                    mobile: !isEmail ? emailOrMobile : null,
                     role: selectedRole,
                    otp,
                }
            );


            alert("OTP verified successfully");

            const user = res.data.user;

            // ✅ Store full user data
            localStorage.setItem("user", JSON.stringify(user));

            // ✅ ROLE BASED REDIRECT
            switch (user.role) {
                case "investor":
                    navigate("/homee");
                    break;

                case "projectHead":
                    navigate("/project_head");
                    break;

                case "agent":
                    navigate("/agent_scren");
                    break;

                case "owner":
                    navigate("/propert_owner");
                    break;

                default:
                    alert("Role not recognized");
                    navigate("/");
            }

        } catch (err) {
            alert(err.response?.data?.message || "Invalid OTP");
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user) return;

        switch (user.role) {
            case "investor":
                navigate("/homee");
                break;
            case "projectHead":
                navigate("/project_head");
                break;
            case "agent":
                navigate("/agent_scren");
                break;
            case "owner":
                navigate("/propert_owner");
                break;
            default:
                navigate("/");
        }
    }, []);


    return (
        <div className="pg-container">

            <section className="pg-map animate-zoom">
                <FadeInSection>

                    {/* ROW */}
                    <div className="card-row">

                        {/* LEFT CARD : MAP */}
                        {/* <div className="map-card">
                            <div className="map-wrapper">
                                <img src={mapImg} alt="Map" className="map-img" />

                                <div className="map-pin" style={{ top: "25.5%", left: "74.1%" }} onClick={() => navigate("/location/yadadri")} title="Yadadri" />
                                <div className="map-pin" style={{ top: "34.5%", left: "67.8%" }} onClick={() => navigate("/location/bhuvanagiri")} title="bhuvanagiri" />
                                <div className="map-pin" style={{ top: "13.2%", left: "68.1%" }} onClick={() => navigate("/location/pragnapur")} title="Pragnapur" />
                                <div className="map-pin" style={{ top: "7.2%", left: "57.5%" }} onClick={() => navigate("/location/gajwel")} title="Gajwel" />
                                <div className="map-pin" style={{ top: "4.2%", left: "49.4%" }} onClick={() => navigate("/location/masaipet")} title="Masaipet" />
                                <div className="map-pin" style={{ top: "11.2%", left: "50.1%" }} onClick={() => navigate("/location/toopran")} title="Toopran" />
                                <div className="map-pin" style={{ top: "25%", left: "37.2%" }} onClick={() => navigate("/location/narsapur")} title="Narsapur" />
                                <div className="map-pin" style={{ top: "24.5%", left: "24.8%" }} onClick={() => navigate("/location/sangareddy")} title="sangareddy" />
                                <div className="map-pin" style={{ top: "41.5%", left: "22.2%" }} onClick={() => navigate("/location/nawabpet")} title="nawabpet" />
                                <div className="map-pin" style={{ top: "56.5%", left: "34.4%" }} onClick={() => navigate("/location/chevella")} title="chevella" />
                                <div className="map-pin" style={{ top: "66.5%", left: "31%" }} onClick={() => navigate("/location/shabad")} title="shabad" />
                                <div className="map-pin" style={{ top: "75.5%", left: "35%" }} onClick={() => navigate("/location/shadnagar")} title="shadnagar" />
                                <div className="map-pin" style={{ top: "79.5%", left: "42.3%" }} onClick={() => navigate("/location/keshampet")} title="keshampet" />
                                <div className="map-pin" style={{ top: "89.5%", left: "46.8%" }} onClick={() => navigate("/location/Amangal")} title="Amangal" />
                                <div className="map-pin" style={{ top: "79.1%", left: "57.8%" }} onClick={() => navigate("/location/nagilla")} title="Nagilla" />
                                <div className="map-pin" style={{ top: "89.1%", left: "61.4%" }} onClick={() => navigate("/location/mallkurmapally")} title="Mall-Kurmapally" />
                                <div className="map-pin" style={{ top: "83.1%", left: "70.7%" }} onClick={() => navigate("/location/marrigudem")} title="Marrigudem" />
                                <div className="map-pin" style={{ top: "73.4%", left: "72.9%" }} onClick={() => navigate("/location/shivannaguda")} title="Shivannaguda" />
                                <div className="map-pin" style={{ top: "66.6%", left: "75.4%" }} onClick={() => navigate("/location/samsthan-narayanpur")} title="Samsthan Narayanpur" />
                                <div className="map-pin" style={{ top: "56.2%", left: "76.5%" }} onClick={() => navigate("/location/choutuppal")} title="Choutuppal" />
                                <div className="map-pin" style={{ top: "46.4%", left: "79.4%" }} onClick={() => navigate("/location/valigonda")} title="Valigonda" />
                            </div>
                        </div> */}

                        <div className="map-card">
                            <div className="map-wrapper">
                                <img src={mapImg} alt="Map" className="map-img" />

                                {/* <div className="map-pin" style={{ top: "25.5%", left: "74.1%" }} onClick={() => navigate("/location/yadadri")} title="Yadadri" /> */}
                                <div className="map-pin" style={{ top: "41.5%", left: "60.8%" }}
                                    onClick={() =>
                                        navigate("/highways", {
                                            state: { highway: "WARANGAL HIGHWAY" }
                                        })}
                                    title="WARANGAL HIGHWAY" />
                                <div className="map-pin" style={{ top: "51.5%", left: "59.8%" }} title="VIJAYAWADA HIGHWAY" />
                                onClick={() =>
                                    navigate("/highways", {
                                        state: { highway: "VIJAYAWADA HIGHWAY" }
                                    })}

                                <div className="map-pin" style={{ top: "57.5%", left: "55.8%" }}
                                    onClick={() =>
                                        navigate("/highways", {
                                            state: { highway: "NAGARJUNA SAGAR HIGHWAY" }
                                        })}
                                    title="NAGARJUNA SAGAR HIGHWAY" />

                                <div className="map-pin" style={{ top: "60.5%", left: "50%" }}
                                    onClick={() =>
                                        navigate("/highways", {
                                            state: { highway: "SRISAILAM HIGHWAY" }
                                        })}
                                    title="SRISAILAM HIGHWAY" />
                                <div className="map-pin" style={{ top: "58.5%", left: "44.8%" }}
                                    onClick={() =>
                                        navigate("/highways", {
                                            state: { highway: "BANGLORE HIGHWAY" }
                                        })} title="BANGLORE HIGHWAY" />


                                <div className="map-pin" style={{ top: "48.5%", left: "45%" }}
                                    onClick={() =>
                                        navigate("/highways", {
                                            state: { highway: "MOINABAD VIKARABAD HIGHWAY" }
                                        })} title="MOINABAD VIKARABAD HIGHWAY" />

                                {/* <div className="map-pin" style={{ top: "34.5%", left: "67.8%" }} onClick={() => navigate("/location/bhuvanagiri")} title="bhuvanagiri" />
                                                        <div className="map-pin" style={{ top: "13.2%", left: "68.1%" }} onClick={() => navigate("/location/pragnapur")} title="Pragnapur" />
                                                        <div className="map-pin" style={{ top: "7.2%", left: "57.5%" }} onClick={() => navigate("/location/gajwel")} title="Gajwel" />
                                                        <div className="map-pin" style={{ top: "4.2%", left: "49.4%" }} onClick={() => navigate("/location/masaipet")} title="Masaipet" /> */}
                                <div className="map-pin" style={{ top: "33.2%", left: "38.1%" }}
                                    onClick={() =>
                                        navigate("/highways", {
                                            state: { highway: "MUMBAI HIGHWAY" }
                                        })}
                                    title="MUMBAI HIGHWAY" />
                                <div className="map-pin" style={{ top: "29.2%", left: "47.1%" }}
                                    onClick={() =>
                                        navigate("/highways", {
                                            state: { highway: "MEDAK HIGHWAY" }
                                        })}
                                    title="MEDAK HIGHWAY" />
                                <div className="map-pin" style={{ top: "29.2%", left: "51.1%" }}
                                    onClick={() =>
                                        navigate("/highways", {
                                            state: { highway: "Nagpur HIGHWAY" }
                                        })} title="Nagpur highway" />

                                <div className="map-pin" style={{ top: "30.2%", left: "55.1%" }}
                                    onClick={() =>
                                        navigate("/highways", {
                                            state: { highway: "KARIMNAGAR HIGHWAY" }
                                        })}
                                    title="KARIMNAGAR HIGHWAY" />
                                {/* <div className="map-pin" style={{ top: "11.2%", left: "50.1%" }} onClick={() => navigate("/location/toopran")} title="Toopran" />
                                                        <div className="map-pin" style={{ top: "25%", left: "37.2%" }} onClick={() => navigate("/location/narsapur")} title="Narsapur" />
                                                        <div className="map-pin" style={{ top: "24.5%", left: "24.8%" }} onClick={() => navigate("/location/sangareddy")} title="sangareddy" />
                                                        <div className="map-pin" style={{ top: "41.5%", left: "22.2%" }} onClick={() => navigate("/location/nawabpet")} title="nawabpet" />
                                                        <div className="map-pin" style={{ top: "56.5%", left: "34.4%" }} onClick={() => navigate("/location/chevella")} title="chevella" />
                                                        <div className="map-pin" style={{ top: "66.5%", left: "31%" }} onClick={() => navigate("/location/shabad")} title="shabad" />
                                                        <div className="map-pin" style={{ top: "75.5%", left: "35%" }} onClick={() => navigate("/location/shadnagar")} title="shadnagar" />
                                                        <div className="map-pin" style={{ top: "79.5%", left: "42.3%" }} onClick={() => navigate("/location/keshampet")} title="keshampet" />
                                                        <div className="map-pin" style={{ top: "89.5%", left: "46.8%" }} onClick={() => navigate("/location/Amangal")} title="Amangal" />
                                                        <div className="map-pin" style={{ top: "79.1%", left: "57.8%" }} onClick={() => navigate("/location/nagilla")} title="Nagilla" />
                                                        <div className="map-pin" style={{ top: "89.1%", left: "61.4%" }} onClick={() => navigate("/location/mallkurmapally")} title="Mall-Kurmapally" />
                                                        <div className="map-pin" style={{ top: "83.1%", left: "70.7%" }} onClick={() => navigate("/location/marrigudem")} title="Marrigudem" />
                                                        <div className="map-pin" style={{ top: "73.4%", left: "72.9%" }} onClick={() => navigate("/location/shivannaguda")} title="Shivannaguda" />
                                                        <div className="map-pin" style={{ top: "66.6%", left: "75.4%" }} onClick={() => navigate("/location/samsthan-narayanpur")} title="Samsthan Narayanpur" />
                                                        <div className="map-pin" style={{ top: "56.2%", left: "76.5%" }} onClick={() => navigate("/location/choutuppal")} title="Choutuppal" />
                                                        <div className="map-pin" style={{ top: "46.4%", left: "79.4%" }} onClick={() => navigate("/location/valigonda")} title="Valigonda" /> */}
                                {/* {highwayPoints.map((point, index) => (
                              <div
                                key={index}
                              className="map-pin highway-pin"
                              style={{ top: point.top, left: point.left }}
                               onClick={() => navigate(point.path)}
                               title={`Highway Point ${index + 1}`}
                             />
                                  ))} */}

                            </div>
                        </div>

                        {/* RIGHT CARD : WELCOME */}
                        <div className="welcome-card">
                            <img src={logo} alt="Logo" className="auth-logo" />
                            <h2>Welcome to Property Galleriaa</h2>
                            <p> Discover premium project locations and manage your investments with confidence. </p>
                            {/* here from i want ?*/}

                            {/* BACK BUTTON */}

                            {/* <h1 className="auth-title">Welcome Back</h1>
                            <p className="auth-subtitle">Login to your PlotHub account</p> */}

                            {/* INPUT FIELD */}
                            {/* <div className="auth-input-wrapper">
                                <span className={`auth-icon ${emailOrMobile.includes("@") ? "active" : ""}`}>
                                    {emailOrMobile.includes("@") ? (
                                        /* EMAIL SVG *
                                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                                            <path d="M4 4H20V20H4V4Z" stroke="currentColor" strokeWidth="1.5" />
                                            <path d="M4 6L12 13L20 6" stroke="currentColor" strokeWidth="1.5" />
                                        </svg>
                                    ) : (
                                        /* WHATSAPP SVG *
                                        <svg width="22" height="22" viewBox="0 0 32 32" fill="currentColor">
                                            <path d="M19.11 17.41c-.27-.14-1.6-.79-1.85-.88-.25-.09-.43-.14-.61.14-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.14-1.15-.42-2.19-1.34-.81-.72-1.36-1.61-1.52-1.88-.16-.27-.02-.42.12-.56.13-.13.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.61-1.48-.84-2.03-.22-.53-.45-.46-.61-.47-.16-.01-.34-.01-.52-.01s-.48.07-.73.34c-.25.27-.95.93-.95 2.27s.98 2.63 1.12 2.81c.14.18 1.93 2.95 4.69 4.14.66.28 1.18.45 1.58.57.66.21 1.26.18 1.73.11.53-.08 1.6-.65 1.83-1.28.23-.63.23-1.17.16-1.28-.07-.11-.25-.18-.52-.32z" />
                                        </svg>
                                    )}
                                </span>

                                <input
                                    type="text"
                                    placeholder="Enter email or mobile number"
                                    value={emailOrMobile}
                                    onChange={(e) => setEmailOrMobile(e.target.value)}
                                />
                            </div> */}
                            {/* ROLE DROPDOWN */}
                            <div className="auth-input-wrapper">
                                <select
                                    value={selectedRole}
                                    onChange={(e) => setSelectedRole(e.target.value)}
                                    className="role-dropdown"
                                    disabled={otpSent}
                                >
                                    <option value="">Select Role</option>
                                    <option value="investor">Investor</option>
                                    <option value="agent">Agent</option>
                                    <option value="owner">Owner</option>
                                    <option value="projectHead">Project Head</option>
                                </select>
                            </div>

                            {/* INPUT */}
                            <div className="auth-input-wrapper">
                                <img
                                    src={
                                        emailOrMobile.includes("@")
                                            ? emailActiveIcon || emailIcon
                                            : whatsappIcon
                                    }
                                    alt="icon"
                                    className={`auth-icon-img ${emailOrMobile.includes("@") ? "active" : ""
                                        }`}
                                />

                                <input
                                    type="text"
                                    placeholder="Enter email or mobile number"
                                    // value={emailOrMobile}
                                    // onChange={(e) => setEmailOrMobile(e.target.value)}
                                    value={emailOrMobile}
                                    onChange={(e) => setEmailOrMobile(e.target.value)}
                                    disabled={otpSent}
                                />

                                {otpSent && (
                                    <div className="auth-input-wrapper">
                                        <input
                                            type="text"
                                            placeholder="Enter OTP"
                                            value={otp}
                                            onChange={(e) => setOtp(e.target.value)}
                                        />
                                    </div>
                                )}

                            </div>



                            {/* SEND OTP */}
                            {/* <button className="auth-btn">Send OTP</button> */}
                            {!otpSent ? (
                                <button
                                    className="auth-btn"
                                    onClick={handleSendOtp}
                                    disabled={loading}
                                >
                                    {loading ? "Sending..." : "Send OTP"}
                                </button>
                            ) : (
                                <button
                                    className="auth-btn"
                                    onClick={handleVerifyOtp}
                                    disabled={loading}
                                >
                                    {loading ? "Verifying..." : "Verify OTP"}
                                </button>
                            )}


                            {/* SIGNUP */}
                            <p className="auth-footer">
                                Don’t have an account?
                                <span onClick={() => navigate("/choose-role")}> Sign Up</span>
                            </p>

                            <div className="auth-back" onClick={() => navigate(-1)}>
                                ← Back to LandingPage
                            </div>


                            {/* <button onClick={() => navigate("/login")}>Login</button> */}
                        </div>

                    </div>

                </FadeInSection>
            </section>


        </div>
    );
};

export default Login;
